import { tryOnMounted, until } from '@vueuse/core'
import { useAuthStore } from '@/store/auth'
import { useAppStore } from '@/store/app'

export function useLoginSdkInit(initialize: () => void) {
  const authStore = useAuthStore()
  const appStore = useAppStore()

  tryOnMounted(async () => {
    if (appStore.isWebview) {
      return
    }

    if (!authStore.isAlreadyGetMember) {
      await until(() => authStore.isAlreadyGetMember).toBe(true)
    }

    if (authStore.isLogin) {
      return
    }

    initialize()
  })

  // 處理「已登入 → 登出」的情境：
  // tryOnMounted 只在元件 mount 時執行一次，若使用者進入時已登入，
  // SDK 不會初始化。登出後 isLogin 變 false，需重新觸發 initialize。
  watch(
    () => authStore.isLogin,
    (isLogin, wasLogin) => {
      if (appStore.isWebview) return
      if (wasLogin && !isLogin) {
        initialize()
      }
    }
  )
}
